import { ErrorCode } from '@kreart/shared';
import { makeErrorKeyResolver } from '@/lib/form/errorMessages';

export const errorKeyFor = makeErrorKeyResolver({
  [ErrorCode.CATALOG_NOT_FOUND]: 'catalog.errors.notFound',
  [ErrorCode.CATALOG_SKU_TAKEN]: 'catalog.errors.skuTaken',
  [ErrorCode.CATALOG_NAME_TAKEN]: 'catalog.errors.nameTaken',
  [ErrorCode.CATALOG_INTERNAL_CODE_TAKEN]: 'catalog.errors.internalCodeTaken',
  [ErrorCode.CATALOG_TYPE_IMMUTABLE]: 'catalog.errors.typeImmutable',
  [ErrorCode.CATALOG_IN_USE]: 'catalog.errors.inUse',
  [ErrorCode.NOT_FOUND]: 'catalog.errors.notFound',
});
